import React, { useState } from "react";
import { useParams } from "react-router-dom";

import LocationDetailsLayout from "../../../layouts/details/Location";
import LocationDetailsFormView from "../../../views/details_forms/Location";

import { ILocationData } from "../../../../interfaces/location";

import useGetLocationDetails from "../../../../hooks/locations/useGetLocationDetails";

const LocationDetailsPage = () => {
    const { location_id } = useParams();

    const [formData, setFormData] = useState<ILocationData>({
        id: null,
        identifier: { value: "", error: "" },
        street: { value: "", error: "" },
        city: { value: "", error: "" },
        province: { value: { label: "", value: "" }, error: "" },
        postal: { value: "", error: "" },
        phone: { value: "", error: "" },
        manager: { value: "", error: "" },
        type: { value: { label: "", value: "" }, error: "" },
        full_time_emp: { value: "", error: "" },
        part_time_emp: { value: "", error: "" },
    });

    const { data: location, isLoading, error } = useGetLocationDetails(location_id);

    return (
        <LocationDetailsLayout
            title={location?.identifier ?? 'Location Information'}
            error={!!error}
        >
            <LocationDetailsFormView
                operation='update'
                isLoading={isLoading}
                locationData={location ?? null}
                formData={formData}
                setFormData={setFormData}
            />
        </LocationDetailsLayout>
    );
};

export default LocationDetailsPage;